<!--
  File name: DataBreachForm.vue
  Program Description:
    - This component renders the form containing the fields for a specific
      Data Breach Notification

  Includes:
    - DataBreachForm: component that contains all the fields and functions
      needed for PDBNF operations
    - Operation pulled from the route params
    - Import of meta file containing all the static values, schema and other
      data for PDBNF
-->
<template>
  <v-container flex>
    <DataBreachForm
      ref="dataBreachForm"
      :key="operation"
      v-bind="{ name: 'pdbnf', mdTables }"
    />
  </v-container>
</template>

<script>
import mdTables from '@/meta/mdTable/crudModules'

export default {
  name: 'DataBreachFormHolder',
  computed: {
    operation () {
      return this.$route.params.operation
    },
    mdTables () {
      return mdTables
    }
  },
  created () {
    window.addEventListener('beforeunload', this.beforeWindowUnload)
  },
  beforeDestroy () {
    window.removeEventListener('beforeunload', this.beforeWindowUnload)
  },
  methods: {
    // show confirm window before leaving
    confirmLeave () {
      return window.confirm('Are you sure you want to leave? All unsaved data will be lost.')
    },
    // if not readOnly, trigger confirmLeave()
    confirmStayInDirtyForm () {
      if (!this.$refs.dataBreachForm.readOnly) {
        return !this.confirmLeave()
      }
    },
    // prevent leaving form when user cancels confirmation
    beforeWindowUnload (e) {
      if (!this.$refs.dataBreachForm.readOnly) {
        if (this.confirmStayInDirtyForm()) {
          e.preventDefault()
          // Chrome requires returnValue to be set
          e.returnValue = ''
        }
      }
    }
  },
  beforeRouteLeave (to, from, next) {
    if (!this.$s.session.userRole.includes('guest') && this.confirmStayInDirtyForm()) {
      next(false)
    } else {
      next()
    }
  }
}
</script>
